import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { MenuReminders } from '../../ui-components/Icons';

const reminders = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <MenuReminders  className={props.classes.subHeaderIcon}/>
        <Typography className={props.classes.title} variant='h6'>Promemoria</Typography>
    </div>)
}

export const Reminders = withStyles(styles)(reminders)